import PaddockAvatar from '@/components/ui/paddock-avatar/paddock-avatar';
import useUsers from '@/hooks/use-users';
import type { SalesRep } from '@/models/types';
import { COMBO_BOX_OPTIONS } from '../combobox-popovers/all-filters-combobox-popover';
import SalesRepFiltersComboBoxPopover from '../combobox-popovers/sales-rep-filters-combobox-popover';
import type { SalesRepFilterChipProps, SalesRepFiltersState } from '../types';
import BaseFilterChip from './base-filter-chip';

const SalesRepFilterChipSelectedFilterBadge = ({
  value,
}: {
  value: SalesRep['id'];
}) => {
  // DEV NOTE: for the `my deals filters` we set the `users` to be the `sales reps`
  // even if the user isn't a sales rep
  // thus we need to show avatar for all users
  const { users: salesReps } = useUsers();

  const salesRep = salesReps.find((sr) => sr.id === value);

  if (!salesRep) {
    return null;
  }

  return (
    <PaddockAvatar
      src={salesRep?.avatar}
      alt={salesRep?.first_name}
      fallback={salesRep?.first_name}
      className="size-4"
    />
  );
};

const SalesRepFilterChip = (props: SalesRepFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    <BaseFilterChip<SalesRep['id'], SalesRepFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={SalesRepFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS.find((option) => option.value === 'sales_rep')?.icon
      }
      filterName="Sales Rep"
      filterQuantifier={{
        singular: 'sales rep',
        plural: 'sales reps',
      }}
      SelectedFilterBadge={SalesRepFilterChipSelectedFilterBadge}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
    />
  );
};

export default SalesRepFilterChip;
